import React from "react";
// components
import MenuBar from "./components/UI/MenuBar";
import { Routes, Route } from "react-router-dom";

import HomePage from "./components/pages/Home/HomePage";
import ProfilePage from "./components/pages/Prolfie/ProfilePage";
function App() {
  return (
    <div className="App">
      <MenuBar />
      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="*" element={<>not Found</>} />
        <Route path="/addstory" element={<ProfilePage />}>
       
        </Route>
        <Route path="/explore" element={<>This is explore page</>} />
        <Route path="/notification" element={<>This is Notification</>} />
      </Routes>
    </div>
  );
}

export default App;
